import React from "react";
import {ReactSVG} from 'react-svg'
//https://github.com/nygardk/react-share
import {FacebookShareButton, TwitterShareButton} from 'react-share'
import {Arrow, Close, Pause, Play, Selected, Settings, Share, Sound, SoundOff} from "../components/Icon";
import embed from "../front/img/embed.svg"
import facebook from "../front/img/facebook.svg"
import twitter from "../front/img/twitter.svg"
import styled from "styled-components";
import Slider from "@mui/material/Slider";
import ReactPlayer from "react-player";
import {Box, LinearProgress} from "@mui/material";
import Hls from "hls.js";


const SMALLEST_BUFFER = 600;

export function WithoutLogoClassStyle(logo, initialClasses = "") {
    return logo ? initialClasses : initialClasses + " without-logo";
}

const ImageDiv = styled.div`
    .textToFill {
        fill: ${props => props.color} !important;
    }
`;

const OnAirBlock = (props) => {
    const formatToTitleCase = (title) => {
        return title.replace(/\w\S*/g, function (splittedTitle) {
            return splittedTitle.charAt(0).toUpperCase() + splittedTitle.substring(1).toLowerCase();
        });
    }
    return (<div
        onClick={(event) => props.onChange(props.bufferSize - (props.fragment * 3), true)} id="on-air-block"
        style={props.bufferSize + props.previousPlayTime >= props.bufferSize - props.fragment * 2 ?
            {'backgroundColor': props.secondaryColor, 'color': props.buttonColor}
            :
            {'backgroundColor': '#666666', 'color': props.buttonColor}
        }>
        <p id="on-air">{formatToTitleCase(props.onAirLabel)}</p>
    </div>)
}


export function Timeline(props) {
    const fragment = props.fragment ?? 5;
    const bufferSize = props.fragment * props.playlist;
    const toolTip = document.getElementById('timeline-tooltip');
    const timelineRange = document.getElementById('timeline-range');
    const max = bufferSize - (fragment * 3);

    const convertValueToRange = (value, minInput, maxInput, minOutput, maxOutput) => {
        //équation de mise à l'échelle linéaire
        const linearScaling = ((value - minInput) * (maxOutput - minOutput) / (maxInput - minInput)) + minOutput
        if (linearScaling > maxOutput) return maxOutput;
        if (linearScaling < minOutput) return minOutput;
        return ~~linearScaling;
    }
    const formatTime = (time) => {
        const sign = time < 0 ? "-" : "";
        time = Math.abs(time);

        const hours = Math.floor(time / 3600);
        time %= 3600;
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };
    // @todo fix diplay timeline, need to visible more late
    let isVisible = ((props.streamFormat === 'hls' && !props.neverPlayed && bufferSize >= SMALLEST_BUFFER && !props.isLoading) && !(props.isHlsBuffered) && props.isDirectControl) || props.bufferPreviewed;
    return (
        <>
            <div
                className={`timeline-container ${isVisible ? 'shown' : 'hidden'}`}>
                {
                    props.bufferPreviewed ?
                        <LinearBuffer
                            color={props.secondaryColor} player={props.player}
                            previousPlayTime={props.previousPlayTime}></LinearBuffer>
                        : <></>
                }
                <Slider className="timeline-container-slider" type='range' min={0}
                        max={max}
                        defaultValue={max}
                        value={props.previousPlayTime + max}
                        step={1}
                        id="timeline-range"
                        onChange={(event, value) => props.onChange(value, false)}
                        style={{color: props.buttonColor}}
                        onChangeCommitted={(event, value) => {
                            if (props.onChangeCommittedFlush && props.player?.getInternalPlayer('hls'))
                                props.player.getInternalPlayer('hls').trigger(Hls.Events.BUFFER_FLUSHING, {
                                    startOffset: 0,
                                    endOffset: props.player.getSecondsLoaded(),
                                    type: 'audio'
                                });
                            return props.onChange(value, true)
                        }}
                        onMouseOut={() => {
                            toolTip.style.display = 'none';
                        }}
                        onMouseMove={(event) => {
                            //Cannot display tooltip under 300 px
                            // @todo fix this if possible
                            if (window.innerHeight >= 300 || props.isMedium) {
                                const timelineBoundingRect = timelineRange.getBoundingClientRect()
                                //max input vaut la longueur en pixels de la box + le décalage en pixels en partant du bord gauche de la fenêtre
                                const maxInput = timelineBoundingRect.width + timelineBoundingRect.left;
                                //minInput = juste le décalage en px du bord gauche de l'écran
                                const minInput = timelineBoundingRect.x
                                //  on veut la valeur du buffer - l'interpolation de la valeurCourante de la souris en px
                                //  vers une valeur comprise entre 0 et bufferSize rammenée proportionnellement a la taille de la timeline
                                // toolTip.textContent = "-" + formatTime(bufferSize - (convertValueToRange(event.clientX, minInput, maxInput, props.fragment, bufferSize)));
                                toolTip.textContent = formatTime(-(bufferSize - convertValueToRange(event.clientX, minInput, maxInput, props.fragment, bufferSize)));
                                if (props.isMedium) {
                                    const toolTipWidthString = getComputedStyle(toolTip).width;
                                    const toolTipWidthValue = +(toolTipWidthString.split('px')[0])
                                    toolTip.style.left = `${event.clientX - minInput - (toolTipWidthValue / 2)}px`;
                                } else {
                                    toolTip.style.left = `${event.clientX - minInput}px`;
                                    toolTip.style.bottom = `${timelineBoundingRect.x * 2}px`;
                                }
                                toolTip.style.display = 'flex';
                            } else {
                                toolTip.style.display = 'none';
                            }
                        }}
                ></Slider>
                <div id='timeline-tooltip' style={{color: props.buttonColor}}></div>
                <OnAirBlock className="timeline-container-onAirBlock"
                            previousPlayTime={props.previousPlayTime}
                            fragment={props.fragment}
                            onChange={props.onChange}
                            bufferSize={bufferSize}
                            onAirLabel={props.onAirLabel}
                            secondaryColor={props.secondaryColor}
                            buttonColor={props.buttonColor}
                />
            </div>
        </>
    );
}

export default function LinearBuffer(props) {
    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(0);
    // const [isLoading, setIsLoading] = React.useState(true);
    const progressRef = React.useRef(() => {
    });
    React.useEffect(() => {
        progressRef.current = () => {
            if (props.player?.getCurrentTime() !== undefined) {
                const currentTime = props.player.getCurrentTime();
                const bufferedTime = props.player.getSecondsLoaded();
                const duration = props.player.getDuration();
                if (duration > 0) {
                    const progressValue = (currentTime / duration) * 100;
                    const bufferValue = (bufferedTime / duration) * 100;
                    setProgress(progressValue);
                    setBuffer(bufferValue);
                } else {
                    setProgress(0);
                    setBuffer(0);
                }
            }
        };
    });

    React.useEffect(() => {
        const timer = setInterval(() => {
            progressRef.current();
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, [props.player]);

    function hexToRgb(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    return (
        <Box className='timeline-buffer'>
            <LinearProgress sx={{
                '& .MuiLinearProgress-bar': {
                    backgroundColor: `${props.color} !important`,
                    borderRadius: '100px'
                },
                '& .MuiLinearProgress-dashed': {
                    display: 'none',
                    backgroundImage: `radial-gradient(rgb(${hexToRgb(props.buttonColor)}) 0%, rgb(${hexToRgb(props.buttonColor)}) 16%, transparent 42%)!important`
                },
            }} variant="buffer"
                            value={progress}
                            valueBuffer={buffer}/>
        </Box>
    );
}

export function Image(props) {
    if (props.display) {
        return props.display.split('.').pop() === 'svg' ?
            <ImageDiv id="image" alt="defaultImage" color={props.color} className={props.fadeOut}>
                <ReactSVG src={props.display}/>
            </ImageDiv>
            :
            <img id="image" src={props.display} alt="defaultImage" onLoad={props.onLoad} className="fadeOut"/>;
    }
}

export function ButtonPlayPause(props) {
    return props.playing ?
        <Pause id="pause" onClick={props.onClickPause}
               alt="pause"
               color={props.color}/>
        :
        <Play id="play" onClick={props.onClickPlay}
              alt="play"
              color={props.color}/>;
}

export function ButtonSpeaker(props) {
    return props.muted ?
        <div className="volume-icon-container">
            <SoundOff id="mute" onClick={props.onClick}
                      alt="mute"
                      color={props.color}
                      onMouseEnter={props.onMouseEnter}
                      onMouseLeave={props.onMouseLeave}/>
        </div>
        :
        <div className="volume-icon-container">
            <Sound id="speaker" onClick={props.onClick}
                   alt="speaker"
                   color={props.color}
                   onMouseEnter={props.onMouseEnter}
                   onMouseLeave={props.onMouseLeave}/>
        </div>
}

export function ButtonQuality(props) {
    return props.visible &&
        <Settings
            id="cog"
            alt="cog"
            onClick={() => props.onClick("quality")}
            color={props.color}
        />;
}

export function ButtonQualityOrVolumeContainer(props) {
    return props.visible ?
        <Settings id="cog" alt="cog" onClick={() => props.onClick("quality")}
                  color={props.color}/>
        : <div id="volume-container">
            <Slider type='range' min={0} max={1} step={0.0000001} value={props.volume}
                    defaultValue={props.defaultVolume}
                    id="volume"
                    style={{color: props.color}}
                    onChange={props.onChange}/>
        </div>;
}

export function ButtonShare(props) {
    return props.visible &&
        <Share
            id="share"
            alt="share"
            onClick={() => props.onClick("share")}
            color={props.color}
        />;
}

export function ButtonShareWithTitle(props) {
    let display = <div id="title-container"><p id="title">{props.title}</p></div>;
    if (props.visible) {
        display = <div id="title-share" className="buttons">
            {display}
            <Share id="share" alt="share" onClick={() => props.onClick("share")}
                   color={props.color}/>
        </div>;
    }
    return display;
}

export function NumberListener(props) {
    return (props.numberListener >= props.listenerHold && props.displayListener && !props.error) &&
        <p id="number-listener">{props.numberListener} {props.numberListener > 1 ? props.translations.listeners.toUpperCase() : props.translations.listener.toUpperCase()}</p>;
}

export function OverlayQuality(props) {
    let mainDisplay = "";
    if (props.streams.length > 1) {
        let displayQuality = [];
        for (let i = 0; i < props.streams.length; i++) {
            const stream = props.streams[i];

            // If is default url display checked mark
            let selected = props.stream.uuid === stream.uuid ? <Selected className={"option-check"} alt="selected"
                                                                         color={props.buttonColor}/> : "";
            // Add path between quality
            if (i > 0) {
                displayQuality.push(<span key={"path-" + i} className="path"/>);
            }
            let bitrate = stream.format === "hls" ? 'auto' : stream.bitrate + " Kbps";

            displayQuality.push(
                <div key={i} id={"stream" + stream.uuid} className="option-text-container"
                     onClick={() => {
                         let streamQuality = props.streams[i];
                         props.load(streamQuality);
                         props.onClickClose("quality");
                     }}>
                    <div className="option-format">
                        {stream.format.toUpperCase()}
                        {selected}
                    </div>
                    <div className="option-bitrate">{bitrate}</div>
                </div>
            );
        }

        // Wrap qualities in container
        displayQuality = <div id="option-container">
            {displayQuality}
        </div>

        if (props.addTitle) {
            // Wrap container in new container with title
            displayQuality =
                <div id="option-title-container">
                    <div id="title-quality">{props.translations.quality}</div>
                    {displayQuality}
                </div>;
        }

        // Wrap container in the overlay
        mainDisplay = <div key="quality-overlay" id='quality-overlay'
            // f2 for 0.95 transparence
                           style={{backgroundColor: props.backgroundColor + "f2"}}>
            <div className='close-container'>
                <Close className='close-button' alt="close"
                       onClick={() => props.onClickClose("quality")}
                       color={props.buttonColor}/>
            </div>
            {displayQuality}
        </div>;
    }
    return mainDisplay;
}

export function OverlayShare(props) {
    let shareIframe = props.embedEnable ?
        <>
            <button className="react-share__ShareButton">
                <img src={embed} alt="embed" onClick={function () {
                    document.getElementById("share-iframe").classList.toggle('fadeIn')
                }}/>
            </button>
            <input id="share-iframe"
                   defaultValue={"<iframe style='height:" + window.innerHeight + "px;width=" + window.innerWidth + "px;' src='" + window.location.href + "'>"}
                   readOnly onFocus={e => e.target.select()}/>
        </> : "";

    let shareFacebook = props.facebook ? <FacebookShareButton url={props.facebook}>
        <img src={facebook} alt="facebook"/>
    </FacebookShareButton> : "";


    let shareTwitter = props.twitter ?
        <TwitterShareButton url={props.twitter} hashtags={props.twitterHashtags} via={props.twitterAccount}>
            <img src={twitter} alt="twitter"/>
        </TwitterShareButton> : "";


    // f2 for 0.95 transparence
    let display = props.embedEnable || props.facebook || props.twitter ?
        <div id='share-overlay' style={{backgroundColor: props.backgroundColor + "f2"}}>
            <div className='close-container'>
                <Close className='close-button' alt="close"
                       onClick={() => props.onClickClose("share")}
                       color={props.buttonColor}/>
            </div>
            <div id="share-container">
                <p>{props.translations.share}</p>
                <p id="share-url">{window.location.href}</p>
                <div id="social-media-buttons">{shareIframe}{shareFacebook}{shareTwitter}</div>
            </div>
        </div> : "";


    return display;
}

export function OverlayPlay(props) {
    return props.visible && <div id="circle-play">
                        <span id="play-image" className="cursor-pointer front-index"
                              onClick={props.onClick}
                              style={{backgroundColor: props.backgroundColor}}/>
        <Play color={props.buttonColor}/>
    </div>;
}


/*
*
* Super Player functions
*
*/

const PlayerExtend = styled.div`
    ::-webkit-scrollbar-thumb {
        background: ${props => props.scrollColor};
    }
`;

export function ArrowButton(props) {
    if (props.stations && props.stations.length > 0) {
        return <div id='player-arrow' className={props.isExtend ? 'open' : 'close'}
                    onClick={props.onClick}
            // f2 for 0.95 transparence
                    style={{backgroundColor: props.backgroundColor + "f2"}}>
            <Arrow alt="arrow" color={props.buttonColor}/>
        </div>;
    }
}

export function Extend(props) {

    if (props.stations && props.stations.length > 0) {
        let stationsRender = [];

        for (let i = 0; i < props.stations.length; i++) {
            let selected = "";
            let borderColor = {};
            if (props.stations[i].streams[0].uuid === props.streams[0].uuid) {
                borderColor = {borderColor: props.buttonColor};
                selected = "selected";
            }
            let station = props.stations[i];
            stationsRender.push(<div key={station.id} className='station-thumbnail'>
                <img src={station.thumbnail} alt={station.playername} className={selected}
                     style={borderColor}/>
                <div className='play-station-overlay' onClick={() => props.onClick(i)}>
                     <span id="play-station-image" className="cursor-pointer front-index"
                         // f2 for 0.95 transparence
                           style={{backgroundColor: props.backgroundColor}}/>
                    <Play color={props.buttonColor}/>
                </div>
            </div>);
        }
        return <PlayerExtend id='player-extended' className={props.isExtend ? 'open' : 'close'}
                             scrollColor={props.buttonColor}
                             style={{backgroundColor: props.backgroundColor + "f2"}}>
            {stationsRender}
        </PlayerExtend>;
    }

}

/**
 *
 * Common React Player
 *
 */


export function CustomReactPlayer(props) {

    return <ReactPlayer
        id="react-player"
        ref={props.myRef}
        className='react-player'
        url={props.url}
        playing={props.playing}
        light={props.light}
        playbackRate={props.playbackRate}
        volume={props.volume}
        muted={props.muted}
        height={0}
        onReady={props.onReady}
        onPlay={props.onPlay}
        onProgress={e => props.onProgress(e)}
        onError={e => {
            // real error
            if (e.type && !props.neverPlayed && props.playing && !props.preview) {
                props.setPlayerInError(props.unavailableUrl);
            } else {
                // not real error
                props.onReady();
            }
        }}
        config={{...hlsConfigFromPlayerProps(props)}}
    />
}

function hlsConfigFromPlayerProps(props) {
    if (!props.isDirectControl && props.isHlsBuffered) {
        return {
            file: {
                attributes: {
                    crossOrigin: "anonymous"
                },
                hlsOptions: {
                    // Taille du buffer déjà lu à garder en cache (en seconde)
                    // Taille maximum du buffer pas encore lu à garder en cache (en seconde)
                    frontBufferFlushThreshold: Infinity,
                    enableWorker: true,
                    lowLatencyMode: true,
                    backBufferLength: 0,
                    maxMaxBufferLength: Infinity,
                    maxBufferLength: Infinity,
                    maxBufferSize: Infinity,
                    // Nombre de seconde de décalage avec le live (en seconde)
                    liveSyncDuration: props.fragment * 3
                }
            }
        }
    }
    return {
        file: {
            attributes: {
                crossOrigin: "anonymous"
            },
            hlsOptions: {
                // Taille du buffer déjà lu à garder en cache (en seconde)
                backBufferLength: 0,
                // Taille maximum du buffer pas encore lu à garder en cache (en seconde)
                maxMaxBufferLength: props.playlist * (props.fragment),
                // Nombre de seconde de décalage avec le live (en seconde)
                liveSyncDuration: props.fragment * 3
            }
        }
    };
}
